import { defineComponent as _defineComponent } from 'vue'
import {
  nextTick,
  PropType,
  ref,
  unref,
  watch,
} from 'vue';
import {
  DebitType,
  SepaType,
  TransactionType,
} from "@/Enums";
import {
  useI18n,
} from "@/composables/useI18n";
import {
  TransactionTypeFilter,
} from "@/components/bankTransfers/scripts";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankTransferSearchFilter',
  props: {
  transactionTypes: {
    required: true,
    type: Array as PropType<TransactionTypeFilter[]>
  }
},
  emits: [
  'onFilterUpdate',
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();



const selectedSepaType = ref<SepaType>(SepaType.all);
const selectedTransactionType = ref<TransactionType>(TransactionType.all);
const selectedDebitType = ref<DebitType>(DebitType.all);
const selectedState = ref<number | undefined>(-1);
const selectedAccountingStartDate = ref<string | undefined>();
const selectedAccountingEndDate = ref<string | undefined>();



const sepaTypes = [
  {
    id: SepaType.all,
    value: t("sepa_type_all"),
  },
  {
    id: SepaType.pain_001_003_03,
    value: t("sepa_type_credit"),
  },
  {
    id: SepaType.pain_008_003_02,
    value: t("sepa_type_debit"),
  },
];

const debitTypes = [
  {
    id: DebitType.all,
    value: t("debit_type_all"),
  },
  {
    id: DebitType.company,
    value: t("debit_type_company"),
  },
  {
    id: DebitType.basic,
    value: t("debit_type_basic"),
  },
];

const errorTypes = [
  {
    id: -1,
    value: t("state_all"),
  },
  {
    id: false,
    value: t("state_without_error"),
  },
  {
    id: true,
    value: t("state_with_error"),
  },
];

const getSelectedSepaType = () => {
  if (selectedSepaType.value === SepaType.all) return undefined;

  return unref(selectedSepaType);
}

const getSelectedTransactionType = () => {
  if (selectedTransactionType.value === TransactionType.all) {
    return props.transactionTypes?.filter((type: TransactionTypeFilter) => type.id !== TransactionType.all)
      .map((type: TransactionTypeFilter) => type.id);
  }

  return unref(selectedTransactionType);
}

const getSelectedErrorState = () => {
  if (selectedState.value === -1) return undefined;

  return unref(selectedState);
}

const getSelectedDebitType = () => {
  if (selectedDebitType.value === DebitType.all) return undefined;

  return unref(selectedDebitType);
}

const onHandleChange = () => {
  emits('onFilterUpdate', {
    sepaType: getSelectedSepaType(),
    transactionType: getSelectedTransactionType(),
    debitType: getSelectedDebitType(),
    hasError: getSelectedErrorState(),
    accountingStartDate: unref(selectedAccountingStartDate),
    accountingEndDate: unref(selectedAccountingEndDate)
  });
};

const onHandleClearErrorState = async () => {
  //wait for vdom updates of vuetify and then set selected states
  await nextTick();
  selectedState.value = -1;
};

const onHandleClearSepaType = async () => {
  //wait for vdom updates of vuetify and then set selected states
  await nextTick();
  selectedSepaType.value = SepaType.all;
};

const onHandleClearTransactionType = async () => {
  //wait for vdom updates of vuetify and then set selected states
  await nextTick();
  selectedTransactionType.value = TransactionType.all;
};

const onHandleClearDebitType = async () => {
  //wait for vdom updates of vuetify and then set selected states
  await nextTick();
  selectedDebitType.value = DebitType.all;
};

const onHandleClearAccountingStartDate = () => {
  selectedAccountingStartDate.value = undefined;
};

const onHandleClearAccountingEndDate = () => {
  selectedAccountingEndDate.value = undefined;
};

watch([
  selectedSepaType,
  selectedTransactionType,
  selectedDebitType,
  selectedState,
  selectedAccountingStartDate,
  selectedAccountingEndDate
], () => {
  onHandleChange();
});

return { __sfc: true,t, emits, selectedSepaType, selectedTransactionType, selectedDebitType, selectedState, selectedAccountingStartDate, selectedAccountingEndDate, props, sepaTypes, debitTypes, errorTypes, getSelectedSepaType, getSelectedTransactionType, getSelectedErrorState, getSelectedDebitType, onHandleChange, onHandleClearErrorState, onHandleClearSepaType, onHandleClearTransactionType, onHandleClearDebitType, onHandleClearAccountingStartDate, onHandleClearAccountingEndDate }
}

})